import { Box, Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { useTenantContext } from 'shared/contexts';

import Banner from '../../Banner';
import BulletList from './BulletList';
import ImageCover from './ImageCover';

export interface WelcomeBannerProps {
    pageType: 'opportunities' | 'offers' | 'profile' | 'ai-assistant' | 'jobPreferences' | 'requestForOpportunities' | 'candidateAvailability';
}

export default function WelcomeBanner({ pageType }: WelcomeBannerProps) {
    const { t } = useTranslation('navigation');
    const tenant = useTenantContext();

    const imageSrc = (function getImageAddress() {
        switch (pageType) {
            case 'offers':
                return tenant.candidatePortalBannerUri;
            default:
                return null;
        }
    })();
  
    return (
        <Root>
            <Banner role="banner">
                <Content>
                    <TextContainer>
                        <Typography variant={ imageSrc ? 'h4' : 'h5' }>
                            { t('welcomeBanner.title', { context: pageType }) }
                        </Typography>
                        <Typography variant="body1">
                            { t('welcomeBanner.description', { context: pageType }) }
                        </Typography>

                        <BulletList pageType={ pageType } />
                    </TextContainer>
                    <ImageCover src={ imageSrc } />
                </Content>
            </Banner>
        </Root>
    );
}

const Root = styled(Box)(({ theme }) => ({
    padding: theme.spacing(6),
    paddingBottom: 0
}));

const Content = styled(Stack)(({ theme }) => ({
    justifyItems: 'space-between',
    maxHeight: '50xh',

    [theme.breakpoints.up('sm')]: {
        flexDirection: 'row'
    },

    [theme.breakpoints.down('sm')]: {
        flexDirection: 'column-reverse'
    }
}));

const TextContainer = styled(Stack)(({ theme }) => ({
    flex: 2,
    gap: theme.spacing(4),
    padding: theme.spacing(10),

    h5: {
        fontSize: '1.5rem'
    },

    [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(6)
    }
}));
